import { MASONRY } from 'common/constants';
import { useMasonryDeeplinkInterceptor } from 'hooks/use-masonry-deeplink-interceptor/use-masonry-deeplink-interceptor.hook';

/**
 * While mounted, intercepts the Masonry `deeplink` action so the ineligibility
 * screen's Close button runs `onSignOut` instead of navigating.
 */
export const useEligibilitySignOut = (onSignOut: () => void) => {
  useMasonryDeeplinkInterceptor(
    MASONRY.DEEPLINK_ELIGIBILITY_SIGN_OUT,
    onSignOut,
  );
};
